import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Spinner } from 'reactstrap';
import Lottie from 'react-lottie';
import animationData from './lottie/celebration.json';
import { AuthWizardContext } from '../../../context/Context';
import { signUp } from '../../../helpers/api/auth';

// Paso del wizard donde vive cada campo que el backend puede reportar como duplicado
const FIELD_STEPS = {
  username: 1,
  password: 1,
  firstname: 2,
  lastname: 2,
  dni: 2,
  phone: 2,
  address: 2,
};

const parseDuplicateErrors = (errors) => {
  if (!errors) return [];
  return Object.keys(errors).map((key) => {
    const message = Array.isArray(errors[key]) ? errors[key][0] : errors[key];

    const condoMatch = /^condominiums\.(\d+)\.(\w+)$/.exec(key);
    if (condoMatch) {
      return {
        message,
        step: 3,
        condoIndex: parseInt(condoMatch[1], 10),
        condoField: condoMatch[2],
      };
    }

    return { field: key, message, step: FIELD_STEPS[key] || 1 };
  });
};

const Success = () => {
  const { setStep, user, setUser } = useContext(AuthWizardContext);
  const [error, setError] = useState(false)
  const [errorInfo, setErrorInfo] = useState(null)
  const [success, setSuccess] = useState(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  useEffect(() => {
    const saveUser = async () => {
      try {
        await signUp(user);
        setSuccess(true);
      } catch (responseError) {
        setError(true);
        const errorList = parseDuplicateErrors(responseError?.errors);
        setErrorInfo(errorList);

        if (errorList.length > 0) {
          const fieldErrors = {};
          const condoFieldErrors = [];
          errorList.forEach((info) => {
            if (info.condoIndex !== undefined) {
              condoFieldErrors.push({ index: info.condoIndex, field: info.condoField, message: info.message });
            } else {
              fieldErrors[info.field] = info.message;
            }
          });

          setUser((prev) => ({
            ...prev,
            ...(Object.keys(fieldErrors).length > 0 ? { _fieldErrors: fieldErrors } : {}),
            ...(condoFieldErrors.length > 0 ? { _condoFieldErrors: condoFieldErrors } : {}),
          }));
        }
      }
    }
    saveUser()
  }, []); // eslint-disable-line

  const goFixField = () => {
    if (!errorInfo || errorInfo.length === 0) {
      setStep(1);
      return;
    }
    setStep(Math.min(...errorInfo.map((info) => info.step)));
  }

  const errorBlockCode = () => {
    const hasFieldErrors = errorInfo && errorInfo.length > 0;

    return (
      <Row>
        <Col className="text-center">
          <h4 className="mb-1">No pudimos completar tu registro</h4>
          {hasFieldErrors ? (
            <ul className="list-unstyled fs-0 text-left d-inline-block mb-0">
              {errorInfo.map((info, idx) => (
                <li key={idx} className="mb-1">• {info.message}</li>
              ))}
            </ul>
          ) : (
            <p className="fs-0">Ocurrió un problema al guardar tus datos. Por favor verifica la información ingresada e intenta nuevamente.</p>
          )}

          <Button color="danger" className="px-5 my-3 text-white" onClick={goFixField}>
            Corregir datos
          </Button>
        </Col>
      </Row>)
  }

  const successBlockCode = () => {
    return (
      <Row>
        {
          success ?
            <Col className="text-center">
              <div className="wizard-lottie-wrapper">
                <div className="wizard-lottie mx-auto">
                  <Lottie options={defaultOptions} />
                </div>
              </div>
              <h4 className="mb-1">Tu cuenta ha sido creada con exito!</h4>
              <p className="fs-0">Ahora puedes acceder a tu cuenta</p>
              <Link to="/authentication/login">
                <Button color="primary" className="px-5 my-3 text-white">
                  Acceder
                </Button>
              </Link>
            </Col>
            :
            <Col className="text-center">
              <Spinner color="primary" />
              <p className="fs-0" style={{ marginTop: 20 }}>Guardando por favor espere...</p>
            </Col>
        }
      </Row>
    )
  }

  return (
    <Fragment>
      {error?errorBlockCode():successBlockCode()}
    </Fragment>
  )
}

export default Success;